export namespace IFairePay {
  export enum EnrolmentState {
    ENROLMENT_STATE_UNKNOWN = 'ENROLMENT_STATE_UNKNOWN',
    PRE_ENROLLED = 'PRE_ENROLLED',
    PRE_ENROLLED_CHECKED_OUT = 'PRE_ENROLLED_CHECKED_OUT',
    FULLY_ENROLLED = 'FULLY_ENROLLED',
  }

  export enum State {
    STATE_UNKNOWN = 'STATE_UNKNOWN',
    ACTIVE = 'ACTIVE',
    DEFAULTED = 'DEFAULTED',
    CLOSED = 'CLOSED',
    SOFT_DEFAULTED = 'SOFT_DEFAULTED',
    CLOSED_PENDING_PAYOFF = 'CLOSED_PENDING_PAYOFF',
  }

  export enum PaymentPreference {
    PAYMENT_PREFERENCE_UNKNOWN = 'PAYMENT_PREFERENCE_UNKNOWN',
    STATEMENT_BALANCE = 'STATEMENT_BALANCE',
    MINIMUM_PAYMENT = 'MINIMUM_PAYMENT',
    MANUAL = 'MANUAL',
  }

  /**
   * Return an instance of IFairePay with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IFairePay>): IFairePay =>
    ({
      ...(partial ?? {}),
    }) as IFairePay;
}

export interface IFairePay {}
